export enum RequestsAndOperationsEnum {
    ENERGY = "ENERGY",
    SERVICES = "SERVICES",
    BENEFITS = "BENEFITS",
    EDPHEALTH = "EDPHEALTH",
    GENERAL = "GENERAL"
}
